export const alSareeCaseStudy = {
  ar: {
    intro: "صمّمت وطوّرت السريع للتوصيل من الواجهة والخادم إلى الأتمتة والعمليات المحاسبية. يجمع النظام رحلة الطلب في سجل واحد تتشارك فيه خدمة العملاء والتجار والسائقون والإدارة، مع تحديثات لحظية وتنبيهات تساعد على اتخاذ القرار.",
    heading: "كيف تسير العملية، وأين تقل الأخطاء؟",
    riskLabel: "مشكلة العمل اليدوي",
    solutionLabel: "معالجة النظام",
    steps: [
      {
        title: "تسجيل الطلب وتوزيعه",
        risk: "نقل تفاصيل الطلب بين الموظف وفريق السائقين عبر رسائل متفرقة يفتح المجال لتكرار الإدخال، سقوط معلومة، أو تأخر وصول الطلب إلى الفريق الصحيح.",
        solution: "يسجّل موظف العملاء الطلب مرة واحدة، فيظهر فوراً لفريق المندوبين مع إشعار. يبحث الفريق عن السائق الأقرب ويعيّنه من السجل نفسه، فتعمل الأطراف على التفاصيل والحالة ذاتها.",
      },
      {
        title: "إبلاغ السائق والعميل",
        risk: "بعد التعيين، قد ينسى الموظف إرسال إحدى الرسالتين أو ينسخ رقماً أو تفصيلاً خطأً عند كتابة رسائل واتساب يدوياً.",
        solution: "بمجرد تعيين السائق، يرسل النظام تفاصيل الطلب إليه تلقائياً عبر واتساب، ويرسل للعميل إشعار التعيين ورقم السائق. تُنشأ الرسالتان من بيانات الطلب نفسها دون إعادة كتابتها.",
      },
      {
        title: "طلبات التجار والمخزون",
        risk: "الاعتماد على اتصال أو رسالة لإرسال كل طلب يبطئ العمل، وقد يترك التاجر يرى حالة قديمة أو مخزوناً غير محدث بعد الإلغاء أو التأجيل.",
        solution: "ينشئ التاجر الطلب من منتجاته المخزنة لدى الشركة أو لطرد خارجي؛ يصل مباشرة إلى إدارة السريع. تتزامن الحالة وتفاصيل السائق والإلغاء والتأجيل بين اللوحتين، مع متابعة المخزون والحسابات ومحادثة مباشرة.",
      },
      {
        title: "سياق العميل والشكاوى",
        risk: "قد يبدأ الموظف طلباً دون معرفة سجل العميل أو ملاحظة مهمة عنه، وقد تتشتت الشكوى بين المحادثات فلا تصل إلى الإدارة بصورة قابلة للمتابعة.",
        solution: "يجمع CRM طلبات كل عميل وإيراداته وتصنيفه بحسب التوصيلات المكتملة والإلغاءات، ويُظهر ملاحظاته قبل إنشاء طلب جديد. تُرفع المشكلات عبر تذاكر واضحة يمكن للإدارة متابعتها.",
      },
      {
        title: "الرقابة المبكرة والقرارات",
        risk: "يصعب رصد تراجع نشاط تاجر، أو تكرار إلغاء سائق، أو ساعات الذروة من متابعة الجداول والطلبات واحداً واحداً.",
        solution: "تجمع صفحة المستشار الذكي التجار المعرضين للخطر، توقعات الإيرادات، تنبيهات الطلب المرتفع، المسارات النشطة، شكاوى السائقين وإلغاءاتهم، وخريطة حرارية للمناطق الأكثر عملاً. تعتمد التحليلات على بيانات النظام المتراكمة.",
      },
      {
        title: "السائقون والعمولات والمحاسبة",
        risk: "توزّع مستندات السائقين والأرصدة وطرق الشحن والعمولات على سجلات منفصلة يزيد احتمال اختلاف الحسابات أو استمرار إرسال طلب إلى حساب محظور.",
        solution: "يدير النظام تسجيل السائق ومستنداته ورصيده وشحنه وعمولة الطلب، ويعرض أداءه وإيراده خلال أي مدة. يمكن حظره من استقبال الطلبات أو تجميد حسابه ورصيده، مع سير محاسبي داخلي وتطبيق للمدراء لمتابعة العمل.",
      },
    ],
    conclusion: "النتيجة التشغيلية: إدخال أقل للبيانات المكررة، حالات متطابقة بين اللوحات، إشعارات لا تعتمد على تذكّر الموظف، وسياق أوضح للعملاء والسائقين والماليات.",
    screenshotHeading: "لقطات من النظام",
    captions: [
      "إدارة الطلبات: سجل موحّد للطلبات وحالاتها وتوزيعها على السائقين.",
      "بوابة التاجر: الطلبات والمخزون والحالة اللحظية في لوحة واحدة.",
      "المستشار الذكي: تنبؤات الإيرادات والتنبيهات والذروة في شاشة واحدة.",
      "السائقون الأحرار: متابعة النشاط والعمولات وترتيب الأداء.",
    ],
  },
  en: {
    intro: "I designed and built Al Saree end to end, from its interface and backend to automation and accounting workflows. One shared order record connects customer support, merchants, drivers, and management, with live updates and actionable alerts.",
    heading: "How the workflow reduces human error",
    riskLabel: "Manual-work risk",
    solutionLabel: "What the system does",
    steps: [
      {
        title: "Order intake and dispatch",
        risk: "Passing an order between support and dispatch through separate messages can duplicate data entry, omit a detail, or delay the handoff.",
        solution: "A support agent records the order once. The driver team sees it immediately with an alert, finds the nearest driver, and assigns them from the same record, so everyone works from the same details and status.",
      },
      {
        title: "Driver and customer notifications",
        risk: "Writing two WhatsApp messages manually after assignment makes it easy to forget one recipient or copy a number or order detail incorrectly.",
        solution: "Assignment automatically sends the order details to the driver and the driver's number to the customer on WhatsApp. Both messages use the recorded order data without retyping it.",
      },
      {
        title: "Merchant orders and inventory",
        risk: "A call or message for every merchant order slows handoffs. Cancellations and postponements can leave merchants looking at an outdated status or stock balance.",
        solution: "Merchants create orders from goods stored with the company or for external parcels. Orders appear directly in operations, while status, driver details, cancellations, postponements, inventory, accounts, and direct chat stay available in the merchant portal.",
      },
      {
        title: "Customer context and complaints",
        risk: "An agent may start a new order without seeing the customer's history or an important note. Complaints can get lost across conversations.",
        solution: "The CRM brings together each customer's orders, revenue, and segment based on completed deliveries and cancellations. Notes appear before a new order, and complaint tickets give management a traceable follow-up path.",
      },
      {
        title: "Early warnings and decisions",
        risk: "Inactive merchants, repeated driver cancellations, and peak demand are hard to spot by checking orders and spreadsheets one by one.",
        solution: "The insights view brings together at-risk merchants, revenue forecasts, high-demand alerts, active routes, driver cancellations and complaints, and a heatmap of busy areas. Its analysis uses the system's accumulated data.",
      },
      {
        title: "Drivers, commissions, and accounting",
        risk: "Scattered driver documents, balances, top-ups, and commissions can make accounts disagree or let a blocked driver continue receiving work.",
        solution: "The system manages driver onboarding, documents, balances, top-ups, and order commissions. It shows performance and company revenue by period, blocks drivers from new orders or freezes their accounts and balances, and connects to internal accounting and a manager app.",
      },
    ],
    conclusion: "Operationally, the system reduces repeated entry, keeps statuses aligned across portals, automates notifications that staff might forget, and gives teams clearer customer, driver, and financial context.",
    screenshotHeading: "System screenshots",
    captions: [
      "Order management: one record for order status and driver assignment.",
      "Merchant portal: orders, inventory, and live status in one place.",
      "Insights: revenue forecasts, alerts, and demand peaks together.",
      "Freelance drivers: activity, commissions, and performance ranking.",
    ],
  },
  fr: {
    intro: "J'ai conçu et développé Al Saree de bout en bout, de l'interface et du serveur aux automatisations et à la comptabilité. Une fiche de commande commune relie le service client, les commerçants, les livreurs et la direction, avec des mises à jour immédiates.",
    heading: "Comment le parcours réduit les erreurs humaines",
    riskLabel: "Risque du travail manuel",
    solutionLabel: "Réponse du système",
    steps: [
      {
        title: "Saisie et affectation des commandes",
        risk: "Transmettre une commande du service client à l'équipe des livreurs par messages séparés peut imposer une nouvelle saisie, faire oublier un détail ou retarder l'affectation.",
        solution: "Un agent saisit la commande une fois. L'équipe des livreurs la voit aussitôt avec une alerte, cherche le livreur le plus proche et l'affecte depuis la même fiche. Les équipes partagent ainsi les mêmes détails et le même état.",
      },
      {
        title: "Notifications au livreur et au client",
        risk: "Rédiger deux messages WhatsApp à la main après l'affectation peut faire oublier un destinataire ou introduire une erreur dans un numéro ou un détail.",
        solution: "L'affectation envoie automatiquement les détails de la commande au livreur et son numéro au client par WhatsApp. Les deux messages proviennent des données enregistrées, sans nouvelle saisie.",
      },
      {
        title: "Commandes commerçants et stock",
        risk: "Un appel ou un message pour chaque commande ralentit le transfert. Une annulation ou un report peut laisser au commerçant un état ou un stock dépassé.",
        solution: "Le commerçant crée une commande à partir de produits stockés par la société ou pour un colis externe. Elle arrive directement aux opérations, tandis que l'état, le livreur, les annulations, les reports, le stock, les comptes et la discussion restent accessibles dans son portail.",
      },
      {
        title: "Contexte client et réclamations",
        risk: "Un agent peut ouvrir une commande sans voir l'historique du client ou une note importante. Une réclamation peut se perdre dans les conversations.",
        solution: "Le CRM regroupe les commandes, les revenus et la catégorie de chaque client selon les livraisons terminées et les annulations. Les notes apparaissent avant une nouvelle commande, et les tickets permettent à la direction de suivre les réclamations.",
      },
      {
        title: "Alertes précoces et décisions",
        risk: "Il est difficile de repérer les commerçants inactifs, les annulations répétées ou les heures de pointe en parcourant les commandes une par une.",
        solution: "La vue d'analyse réunit les commerçants à risque, les prévisions de revenus, les alertes de forte demande, les trajets actifs, les annulations et réclamations des livreurs, ainsi qu'une carte de chaleur. Elle s'appuie sur les données accumulées par le système.",
      },
      {
        title: "Livreurs, commissions et comptabilité",
        risk: "Des documents, soldes, recharges et commissions répartis dans plusieurs registres peuvent produire des écarts ou laisser un livreur bloqué recevoir des commandes.",
        solution: "Le système gère l'inscription, les documents, le solde, les recharges et les commissions. Il présente les performances et les revenus par période, bloque les nouvelles commandes ou gèle un compte et son solde, avec une comptabilité interne et une application de suivi pour les dirigeants.",
      },
    ],
    conclusion: "Sur le plan opérationnel, le système réduit les ressaisies, synchronise les états entre les portails, automatise les notifications et donne aux équipes un contexte plus clair sur les clients, les livreurs et les finances.",
    screenshotHeading: "Captures du système",
    captions: [
      "Gestion des commandes : une fiche commune pour l'état et l'affectation.",
      "Portail commerçant : commandes, stock et état en temps réel.",
      "Analyse : prévisions, alertes et pics de demande dans une vue.",
      "Livreurs indépendants : activité, commissions et classement.",
    ],
  },
};
